import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { HttpTokenInterceptor } from './interceptors';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { EffectsModule } from '@ngrx/effects';
import { environment } from '../../environments/environment';
import { effects, reducers } from './store';
import { LangStorageService } from './services';

@NgModule({
    declarations: [],
    exports: [StoreModule, EffectsModule],
    imports: [
        CommonModule,
        StoreModule.forRoot(reducers),
        environment.production ? [] : StoreDevtoolsModule.instrument({ maxAge: 50 }),
        EffectsModule.forRoot(effects),
    ],
    providers: [
        { provide: HTTP_INTERCEPTORS, useClass: HttpTokenInterceptor, multi: true },
        LangStorageService,
        provideHttpClient(withInterceptorsFromDi()),
    ],
})
export class CoreModule {}
